"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.preview.title': 'Szczegóły Firmy',
    'company.preview.failedToLoad': 'Błąd przy wczytywaniu informacji o firmie',
    'company.preview.noCompany': 'Brak dostępnych informacji o firmie',
    'company.preview.section.basic_info': 'Podstawowe Informacje',
    'company.preview.section.status': 'Status',
    'company.preview.section.location': 'Lokalizacja',
    'company.preview.section.additional': 'Informacje Dodatkowe',
};
